export type OneclubApp = keyof typeof SOURCE_SYSTEM

export const ONECLUB_APP = ['os', 'oc', 'oscn', 'osvn', 'osth', 'ossg', 'osmy', 'oshk', 'ostw', 'osid', 'osau', 'ow', 'og', 'osus', 'ocg']

export enum ONECLUB_APP_ENUM {
  'os' = 'os',
  'ow' = 'ow',
  'osvn' = 'osvn',
  'og' = 'og',
  'ocg' = 'ocg',
}

export const SOURCE_SYSTEM = {
  os: 'ONESHIP',
  osau: 'ONESHIP',
  oscn: 'ONESHIP',
  osvn: 'ONESHIP',
  osth: 'ONESHIP',
  ossg: 'ONESHIP',
  osmy: 'ONESHIP',
  oshk: 'ONESHIP',
  ostw: 'ONESHIP',
  osid: 'ONESHIP',
  osus: 'ONESHIP',
  ow: 'ONEWAREHOUSE',
  oc: 'ONECLUB',
  og: 'ONEGOODS',
  ocg: 'ONECARGO',
}

export const APP_COUNTRY = {
  os: 'normal',
  osau: 'AU',
  oscn: 'CN',
  osvn: 'VN',
  osth: 'TH',
  ossg: 'SG',
  osmy: 'MY',
  oshk: 'HK',
  ostw: 'TW',
  osid: 'ID',
  ow: 'normal',
  oc: 'normal',
  ocg: 'normal',
}

export const EVENT_IDS = {
  OS: '4359',
  OW: '4358',
}

/**
 * 各应用的服务条款
 */
export const TERMS = {
  ow: {
    default: 'https://www.onewarehouse.net/vip',
    HK: 'https://hk.onewarehouse.net/vip',
    TW: 'https://tw.onewarehouse.net/vip',
    CN: 'https://www.onewarehouse.cn/vip',
  },
  ocg: {
    default: 'https://cdn.oneship.io/assets/static/upload/hJQvSke5YDWyrU7FRNX0B_ONECARGO.html',
  },
  os: {
    default: 'https://cdn.oneship.io/assets/static/upload/tbEAv4s2hTaujrJPSnluS_EN_Global_OneShipTerms.html',
    CN: 'https://www.oneship.cn/terms',
    TW: 'https://cdn.oneship.io/assets/static/upload/hn7aoZNCTmvml3MSHjBrQ_ONESHIP_服務協議.html',
    AU: 'https://cdn.oneship.io/assets/static/upload/kiARzF_HZwqcHW8_tib1L_AU_OneShipTerms.html',
    GB: 'https://cdn.oneship.io/assets/static/upload/3Z0jqhucOkzADIK8Gwp96_UK_OneShipTerms.html',
  },
}

export const APP_TERMS = (app: OneclubApp, country?: string) => {
  // os太多子id，所以特殊处理os
  if (app === 'oscn' || (app === 'os' && country === 'CN')) return TERMS.os.CN
  // os越南不展示
  if (app === 'osvn' || (app === 'os' && country === 'VN')) return null
  if (app.startsWith('os')) {
    //希望使用accounts.oneclub.vip域名所以在这里套一层iframe
    return `${window.location.origin}/terms/${app}?country=${country}`
  }

  const terms = TERMS[app]
  const link = terms?.[country]
  if (link) return link
  if (terms?.default) return terms?.default

  return null
}

export const APP_NAME = {
  os: 'OneShip',
  oscn: 'OneShip',
  osvn: 'OneClub',
  osth: 'OneShip',
  ossg: 'OneShip',
  osmy: 'OneShip',
  oshk: 'OneShip',
  ostw: 'OneShip',
  osid: 'OneShip',
  ow: 'OneWarehouse',
  ocg: 'OneCargo',
}

// scene
export enum SCENE {
  'logout' = 'logout',
}

export const GOOGLE_CDN_OPTIONS = {
  src: 'https://apis.google.com/js/api:client.js',
  checkForExisting: true,
}

export const FACEBOOK_CDN_OPTIONS = {
  src: 'https://connect.facebook.net/en_US/sdk.js',
  checkForExisting: true,
}
